import ContractlistState from "./ContractlistState";
import {ContractlistActionType} from "./actions";
import {AnyAction} from "redux";


const initialState = new ContractlistState();

const ContractlistReducers = (state: ContractlistState = initialState, action: AnyAction): ContractlistState => {

    console.log(ContractlistActionType[action.type] || 'INITIALIZING', action);

    const actionType: ContractlistActionType = action.type;

    switch (actionType) {

        case ContractlistActionType.FETCHING_CONTRACTS:
            return state.withFetchingContracts(action.fetching);

        case ContractlistActionType.SET_CONTRACTS:
            return state.withContracts(action.contracts);

        case ContractlistActionType.SET_PAGE:
            return state.withPage(action.page);

        case ContractlistActionType.SET_SORT_FIELD:
            return state.withSortField(action.sortByField).withSortAscending(false);

        case ContractlistActionType.SET_SORT_ASCENDING:
            return state.withSortAscending(action.isAscending);

        case ContractlistActionType.SET_SEARCH_STRING:
            return state.withSearchString(action.searchString.toLowerCase());

        case ContractlistActionType.SET_FILTER_BY_CURRENT_USER:
            return state.withShowOtherPeoplesContracts(action.showOtherPeoplesContracts);

        case ContractlistActionType.SET_FILTER_BY_TYPE:
            return state.withTypeFilter(action.typeFilter);

        case ContractlistActionType.SET_CURRENT_USER:
            return state.withCurrentUser(action.currentUser);

        case ContractlistActionType.SET_ARCHIVED_FILTER:
            return state.withArchivedFilter(action.showArchivedContracts);

        case ContractlistActionType.SET_CONTRACTS_WITH_CHANGE_INDICATOR:
            return state.withChangeIndicators(action.hasChanges);

        case ContractlistActionType.ADD_CONTRACTS_WITH_CHANGE_INDICATOR:
            const contractsWithChanges = action.contractsWithChanges;
            const currentState = state.contractsWithChangeIndicator;
            const copy: {[contractId: string]: boolean} = {};
            for(let key in currentState) {
                copy[key] = currentState[key];
            }
            for(let key in contractsWithChanges) {
                copy[key] = contractsWithChanges[key];
            }
            return state.withChangeIndicators(copy)

        case ContractlistActionType.SET_TOTAL_NUMBER_OF_CONTRACTS_WITH_FILTER:
            return state.withTotalNumberOfContractsWithCurrentFilter(action.totalNumberOfContractsWithFilter);

        default:
            return state;
    }
};

export default ContractlistReducers;